import { Toaster } from "react-hot-toast";
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Login from "./pages/Login/Login";
import SetPassword from "./pages/Login/SetPassword";
import AdminLogin from "./pages/Admin/AdminLogin";

import ProtectedRoute from "./components/ProtectedRoute";
import FeatureRoute from "./components/FeatureRoute";
import Sidebar from "./components/Sidebar";

import DashboardLayout from "./pages/Dashboard/DashboardLayout";
import DashboardHome from "./pages/Dashboard/DashboardHome";
import Upload from "./pages/Dashboard/Upload";
import Documents from "./pages/Dashboard/Documents";
import SustainabilitySettings from "./pages/Dashboard/SustainabilitySettings";
import CarbonMethodology from "./pages/Dashboard/CarbonMethodology";
import EnvironmentalContext from "./pages/Dashboard/EnvironmentalContext";
import EnvironmentalPolicy from "./pages/Dashboard/EnvironmentalPolicy";
import EnvironmentalAspects from "./pages/Dashboard/EnvironmentalAspects";
import LegalCompliance from "./pages/Dashboard/LegalCompliance";
import ObjectivesTargets from "./pages/Dashboard/ObjectivesTargets";
import RiskOpportunities from "./pages/Dashboard/RiskOpportunities";
import TrainingCompetence from "./pages/Dashboard/TrainingCompetence";
import InternalAudits from "./pages/Dashboard/InternalAudits";
import NonConformance from "./pages/Dashboard/NonConformance";
import ManagementReviews from "./pages/Dashboard/ManagementReviews";
import ControlledDocuments from "./pages/Dashboard/ControlledDocuments";
import EMSReadiness from "./pages/Dashboard/EMSReadiness";
import EMSGovernancePolicy from "./pages/Dashboard/EMSGovernancePolicy";
import ActionsDeadlines from "./pages/Dashboard/ActionsDeadlines";
import OperationalControls from "./pages/Dashboard/OperationalControls";
import EMSAuditTrail from "./pages/Dashboard/EMSAuditTrail";
import ISOEvidencePacks from "./pages/Dashboard/ISOEvidencePacks";
import EMSReminders from "./pages/Dashboard/EMSReminders";
import EMSCertificationWorkflow from "./pages/Dashboard/EMSCertificationWorkflow";
import TeamApprovals from "./pages/Dashboard/TeamApprovals";


import AdminHome from "./pages/Admin/AdminHome";
import AdminClientList from "./pages/Admin/AdminClientList";
import AdminDashboard from "./pages/Admin/AdminDashboard";
import AdminOpsAlerts from "./pages/Admin/AdminOpsAlerts";

export default function App() {
  return (
    <Router>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "var(--card-bg)",
            color: "var(--text)",
            border: "1px solid var(--border)",
          },
        }}
      />

      <Routes>
        {/* Public */}
        <Route path="/login" element={<Login />} />
        <Route path="/set-password" element={<SetPassword />} />
        <Route path="/portal-admin/login" element={<AdminLogin />} />

        {/* Admin */}
        <Route
          path="/portal-admin/home"
          element={
            <ProtectedRoute adminOnly={true}>
              <Sidebar />
              <AdminHome />
            </ProtectedRoute>
          }
        />
        <Route
          path="/portal-admin/dashboard"
          element={
            <ProtectedRoute adminOnly={true}>
              <Sidebar />
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/portal-admin/clients"
          element={
            <ProtectedRoute adminOnly={true}>
              <Sidebar />
              <AdminClientList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/portal-admin/ops-alerts"
          element={
            <ProtectedRoute adminOnly={true}>
              <Sidebar />
              <AdminOpsAlerts />
            </ProtectedRoute>
          }
        />

        {/* Client */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<FeatureRoute feature="overview"><DashboardHome /></FeatureRoute>} />
          <Route path="ems-readiness" element={<FeatureRoute feature="ems_readiness"><EMSReadiness /></FeatureRoute>} />
          <Route path="ems-governance-policy" element={<FeatureRoute feature="ems_governance_policy"><EMSGovernancePolicy /></FeatureRoute>} />
          <Route path="certification-workflow" element={<FeatureRoute feature="certification_workflow"><EMSCertificationWorkflow /></FeatureRoute>} />
          <Route path="actions-deadlines" element={<FeatureRoute feature="actions_deadlines"><ActionsDeadlines /></FeatureRoute>} />
          <Route path="ems-audit-trail" element={<FeatureRoute feature="ems_audit_trail"><EMSAuditTrail /></FeatureRoute>} />
          <Route path="iso-evidence-packs" element={<FeatureRoute feature="iso_evidence_packs"><ISOEvidencePacks /></FeatureRoute>} />
          <Route path="ems-reminders" element={<FeatureRoute feature="reminders_escalations"><EMSReminders /></FeatureRoute>} />
          <Route path="upload" element={<FeatureRoute feature="upload_data"><Upload /></FeatureRoute>} />
          <Route path="documents" element={<FeatureRoute feature="documents"><Documents /></FeatureRoute>} />
          <Route path="carbon-methodology" element={<FeatureRoute feature="carbon_methodology"><CarbonMethodology /></FeatureRoute>} />
          <Route path="sustainability-settings" element={<FeatureRoute feature="overview_settings"><SustainabilitySettings /></FeatureRoute>} />
          <Route path="environmental-context" element={<FeatureRoute feature="environmental_context"><EnvironmentalContext /></FeatureRoute>} />
          <Route path="environmental-policy" element={<FeatureRoute feature="environmental_policy"><EnvironmentalPolicy /></FeatureRoute>} />
          <Route path="environmental-aspects" element={<FeatureRoute feature="environmental_aspects"><EnvironmentalAspects /></FeatureRoute>} />
          <Route path="legal-compliance" element={<FeatureRoute feature="legal_compliance"><LegalCompliance /></FeatureRoute>} />
          <Route path="objectives-targets" element={<FeatureRoute feature="objectives_targets"><ObjectivesTargets /></FeatureRoute>} />
          <Route path="risk-opportunities" element={<FeatureRoute feature="risk_opportunities"><RiskOpportunities /></FeatureRoute>} />
          <Route path="training-competence" element={<FeatureRoute feature="training_competence"><TrainingCompetence /></FeatureRoute>} />
          <Route path="internal-audits" element={<FeatureRoute feature="internal_audits"><InternalAudits /></FeatureRoute>} />
          <Route path="non-conformance" element={<FeatureRoute feature="non_conformance"><NonConformance /></FeatureRoute>} />
          <Route path="management-reviews" element={<FeatureRoute feature="management_reviews"><ManagementReviews /></FeatureRoute>} />
          <Route path="controlled-documents" element={<FeatureRoute feature="controlled_documents"><ControlledDocuments /></FeatureRoute>} />
          <Route path="operational-controls" element={<FeatureRoute feature="operational_controls"><OperationalControls /></FeatureRoute>} />
          <Route path="team-approvals" element={<TeamApprovals />} />
        </Route>

        {/* Root */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}
